import { RANGES, getSpecificDateRanges } from './ranges';

export const defaultSpecificRanges = (i18n, timeZone, minDate, rangeIds) => {
  const defaultRangeIds = [
    RANGES.Custom,
    RANGES.Today,
    RANGES.Yesterday,
    RANGES.ThisWeek,
    RANGES.ThisWeekMon,
    RANGES.Last7Days,
    RANGES.LastWeek,
    RANGES.LastWeekMon,
    RANGES.Last14Days,
    RANGES.ThisMonth,
    RANGES.LastMonth,
    RANGES.Last30Days,
    RANGES.EntireTime,
  ];

  const finalRangeIds = rangeIds !== undefined ? rangeIds : defaultRangeIds;

  return getSpecificDateRanges({
    i18n,
    timeZone,
    minDate,
    rangeIds: Array.isArray(finalRangeIds) ? finalRangeIds : defaultRangeIds,
  });
};
